import React from 'react';
import _ from 'lodash';
import { MenuTypefaces, Menu, MenuScripts, Footer, BackgroundColorChanger, DeviseError, MobileMenu, RecaptchaWidget } from '../components';
import { changeLoginInfo, windowResize } from '../actions';
import { connect } from 'react-redux';
import { Container, Gutter, BorderArea, LeftColumn, RightColumn, Title, FormField, FormBorderWrapper, PrimaryButton, ButtonA, PaddingDiv, ButtonArea, DesktopHr } from '../stylesheets/components';
import styled from 'styled-components';
import { Form, Field } from 'react-final-form';
import media from '../stylesheets/media';

const Fragment = React.Fragment;
const ForgotPasswordArea = styled.div`
  text-align: right;
  ${media.mobileSmall`
    text-align: left;
  `}
`;
const ButtonAreaMainBtns = styled.div`
  ${media.mobileSmall`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: flex-start;

    button {
      margin-bottom: 5px;
    }
  `}
`;

const MenuGutter = styled(Gutter)`
  height: 350px;

  ${media.mobileSmall`
    height: 100px;
  `}
`;

const FormErrorBox = styled.div`
  color: #c62828;
  font-size: 14px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #ffebee;
  border-radius: 4px;
`;

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.props.dispatch(changeLoginInfo(
      this.props.new_user_session_path,
      this.props.current_user,
      this.props.user_signed_in,
      this.props.destroy_user_session_path
    ));

    this.state = {
      recaptchaToken: '',
      isSubmitting: false,
      formErrors: {}
    };

    this.boundResizeHandler = this.resizeHandler.bind(this);
    this.handleRecaptchaTokenChange = this.handleRecaptchaTokenChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.boundResizeHandler);
    this.boundResizeHandler();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.boundResizeHandler);
  }


  resizeHandler(e) {
    this.props.dispatch(windowResize({
      width: window.innerWidth,
      height: window.innerHeight
    }));
  }

  handleRecaptchaTokenChange(token) {
    this.setState({
      recaptchaToken: token
    });
  }

  handleSubmit(e) {
    const isRecaptchaEnabled = !_.isEmpty(this.props.recaptcha_site_key);
    const form = e.currentTarget;
    const email = form.elements['user[email]'] ? form.elements['user[email]'].value.trim() : '';
    const password = form.elements['user[password]'] ? form.elements['user[password]'].value : '';

    const formErrors = {};

    if (_.isEmpty(email)) {
      formErrors.email = "Email can't be blank";
    }

    if (_.isEmpty(password)) {
      formErrors.password = "Password can't be blank";
    }

    if (isRecaptchaEnabled && _.isEmpty(this.state.recaptchaToken)) {
      formErrors.recaptcha = 'Please complete the reCAPTCHA challenge';
    }

    if (!_.isEmpty(formErrors)) {
      e.preventDefault();
      this.setState({ formErrors, isSubmitting: false });
      return;
    }

    // Validation passed - show loading state and allow form to submit
    this.setState({ formErrors: {}, isSubmitting: true });
    // Form will submit naturally to Rails backend
  }

  render() {
    let { products, languages, typefacesPopup, errors, bwMode } = this.props;
    const isRecaptchaEnabled = !_.isEmpty(this.props.recaptcha_site_key);

    const tokenDom = document.querySelector("meta[name=csrf-token]");
    const csrfToken = tokenDom.content;

    return (
      <Fragment>
        <Menu isLogoutEnabled={true} />
        <MenuTypefaces foregroundColor="black" backgroundColor="white" products={products} />
        <MenuScripts languages={languages} />

        {
          typefacesPopup ?
            null :
            <Fragment>
              <BackgroundColorChanger color="#E0E0E0" bwMode="white" />

              <Container bwMode={bwMode} className="no-webfont">
                <BorderArea foregroundColor="black">
                  <MenuGutter />
                  <PaddingDiv>
                    <Title bwMode={bwMode}>
                      Welcome!
                    </Title>
                  </PaddingDiv>
                </BorderArea>
                <BorderArea foregroundColor="black">
                  <DesktopHr foregroundColor="black" />
                  <LeftColumn bwMode={bwMode}>


                    <PaddingDiv>

                      {
                        _.isUndefined(errors) ?
                          null :
                          <DeviseError {...errors} />
                      }

                      {
                        _.isUndefined(this.props.flash.alert) ? null :
                          <div>
                            {this.props.flash.alert}
                            <Gutter h={6} />
                          </div>
                      }

                      {
                        _.isUndefined(this.props.flash.notice) ? null :
                          <div>
                            {this.props.flash.notice}
                            <Gutter h={6} />
                          </div>
                      }

                      {
                        _.isEmpty(this.state.formErrors) ? null :
                          <FormErrorBox>
                            {_.compact([
                              this.state.formErrors.email,
                              this.state.formErrors.password,
                              this.state.formErrors.recaptcha
                            ]).join(' ')}
                          </FormErrorBox>
                      }

                      <Form
                        onSubmit={this.handleSubmit.bind(this)}
                        render={({ submitting, pristine }) => (
                          <form method="post" action={this.props.session_create_path} onSubmit={this.handleSubmit.bind(this)}>
                            <input type="hidden" name="authenticity_token" value={csrfToken} />
                            <input type="hidden" name="recaptcha_token" value={this.state.recaptchaToken} />
                            <input type="hidden" name="g-recaptcha-response" value={this.state.recaptchaToken} />
                            <FormBorderWrapper bwMode={bwMode}>
                              <FormField bwMode={bwMode}>
                                <label>Email</label>
                                <Field
                                  name="user[email]"
                                  component="input"
                                  type="email"
                                  autoFocus={true}
                                  autoComplete="username"
                                  placeholder="abc@universalthirst.com"
                                />
                              </FormField>
                              <FormField bwMode={bwMode}>
                                <label>Password</label>
                                <Field
                                  name="user[password]"
                                  component="input"
                                  type="password"
                                  autoComplete="current-password"
                                  placeholder="*******"
                                />
                              </FormField>

                            </FormBorderWrapper>
                            <RecaptchaWidget
                              siteKey={this.props.recaptcha_site_key}
                              onTokenChange={this.handleRecaptchaTokenChange}
                            />
                            <Gutter h={20} />

                            <ButtonArea>
                              <ButtonAreaMainBtns>
                                <PrimaryButton bwMode={bwMode} type="submit" disabled={this.state.isSubmitting || (isRecaptchaEnabled && _.isEmpty(this.state.recaptchaToken))}>
                                  {this.state.isSubmitting ? 'Processing...' : 'Login'}
                                </PrimaryButton>
                                <ButtonA bwMode={bwMode} href={this.props.new_registration_path}>
                                  Create Account
                                </ButtonA>
                              </ButtonAreaMainBtns>
                              <ForgotPasswordArea>
                                <a href={this.props.new_password_path}>Forgot password?</a>
                              </ForgotPasswordArea>
                            </ButtonArea>
                          </form>
                        )}
                      />
                    </PaddingDiv>
                  </LeftColumn>
                  <RightColumn>
                  </RightColumn>
                </BorderArea>


              </Container>
              <Footer foregroundColor="black" />
            </Fragment>
        }

        <MobileMenu isLogoutEnabled={true} backgroundColor="#E0E0E0" foregroundColor="black" highlightColor="#000000" />
      </Fragment>
    );
  }
}

let mapStateToProps = state => {
  return {
    typefacesPopup: state.typefacesPopup,
    bwMode: state.bwMode
  }
}

export default connect(mapStateToProps)(SignIn);